import { httpGet } from 'utils';
import { CashBalanceResponse } from 'views/shared/types';

export const fetchCashBalance = () => httpGet<CashBalanceResponse>('portal/CashBalance');
